import {IQuotationStatusOptionsApi} from "../../models";

export type QuotationStatusVisualVariant =
    | "draft"
    | "ready to send"
    | "sent"
    | "follow up"
    | "confirmed"
    | "lost"
    | "default"

export type QuotationStatusIds = {
    draftStatusId: number
    /** Legacy Preview lookup until generic-data ids are wired. Maps to "ready to send". */
    createdStatusId?: number
    /** Legacy Preview lookup until generic-data ids are wired. Maps to "confirmed". */
    finalStatusId?: number
    readyToSendStatusId?: number
    sentStatusId?: number
    followUpStatusId?: number
    confirmedStatusId?: number
    lostStatusId?: number
}

export const variantFromKnownName = (statusName: string): QuotationStatusVisualVariant | null => {
    switch (String(statusName || "").trim().toLowerCase()) {
        case "draft":
            return "draft"
        case "ready to send":
            return "ready to send"
        case "sent":
            return "sent"
        case "follow up":
            return "follow up"
        case "confirmed":
            return "confirmed"
        case "lost":
            return "lost"
        default:
            return null
    }
}

/** Map list / display status_name to pill variant (case-insensitive). Unknown names stay "draft". */
export function quotationStatusVariantFromLabel(statusName: string): QuotationStatusVisualVariant {
    return variantFromKnownName(statusName) ?? "draft"
}

/** Map quotation version row: known name first, then generic / legacy status ids. Unknown stays "draft". */
export function quotationStatusVariantFromVersion(
    version: any,
    ids: QuotationStatusIds,
): QuotationStatusVisualVariant {
    const fromName = variantFromKnownName(version?.quotation_status_name)
    if (fromName) return fromName

    const quotationStatusId = Number(version?.quotation_status_id ?? version?.quotation_status_id ?? 0)
    const matchesId = (id?: number) => Number(id) > 0 && quotationStatusId === Number(id)

    if (matchesId(ids.draftStatusId)) return "draft"
    if (matchesId(ids.readyToSendStatusId) || matchesId(ids.createdStatusId)) return "ready to send"
    if (matchesId(ids.sentStatusId)) return "sent"
    if (matchesId(ids.followUpStatusId)) return "follow up"
    if (matchesId(ids.confirmedStatusId) || matchesId(ids.finalStatusId)) return "confirmed"
    if (matchesId(ids.lostStatusId)) return "lost"
    return "draft"
}

export const getQuotationStatusIdFromQuotationStatusName = (statusName: IQuotationStatusOptionsApi | QuotationStatusVisualVariant) => {
    const lowerStatusName = statusName.toLowerCase() as QuotationStatusVisualVariant;
    switch (lowerStatusName) {
        case "draft": return 1;
        case "ready to send": return 2;
        case "sent": return 3;
        case "follow up": return 4;
        case "confirmed": return 5;
        case "lost": return 6;
        default: return 1;
    }
}